import styled, { DefaultTheme } from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

import { Severity } from './types'

export const Container = styled.div<{
  severity: Severity
}>`
  background-color: ${o => mapSeverityToColor(o.severity, o.theme)};
  font-size: 13px;
  font-weight: bold;
  color: ${o => o.theme.color.deprecated.white.primary};
  line-height: 20px;
  padding: 24px;

  ${fromMd} {
    padding: 12px;
  }
`

function mapSeverityToColor(severity: Severity, theme: DefaultTheme): string {
  switch (severity) {
    case 'error':
      return theme.color.deprecated.red.error
    case 'info':
      return theme.color.deprecated.info
    case 'success':
      return theme.color.deprecated.completed
  }
}
